export default __webpack_public_path__ + "static/media/info_button_meteor.991e4b1b.png";